export class PdpExportCriteria {
	numeroPdp!: string;
	agenceId?: number;
	antenneId?: number;
	parcId?: number;
	entrepriseId?: number;
	generalSpe!: PdpExportCriteriaOption[];
	etat!: PdpExportCriteriaOption[];
	validite!: string;
}

export class PdpExportCriteriaOption {
	key!: string;
	selected!: boolean;
	
	constructor(key: string, selected: boolean) {
		this.key = key;
		this.selected = selected;
	}
}